/**
 * Slideshow voor sections/dw-slideshow.liquid.
 * - Pijlen, bolletjes, toetsen (links/rechts) en vegen op touchscreens.
 * - data-autoplay="true": wisselt elke data-speed seconden; pauzeert bij aanwijzen/focus,
 *   staat uit bij 'minder beweging' en in de theme editor.
 * - Video's spelen alleen op de actieve slide.
 * - In de theme editor springt hij naar het geselecteerde blok.
 */
if (!customElements.get('dw-slideshow')) {
  customElements.define(
    'dw-slideshow',
    class DwSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.dw-ss__slide')];
        this.dots = [...this.querySelectorAll('.dw-ss__dot')];
        this.track = this.querySelector('.dw-ss__track');
        this.index = 0;
        if (this.slides.length < 2) return this.syncVideos();

        this.querySelectorAll('.dw-ss__arrow').forEach((btn) =>
          btn.addEventListener('click', () => this.go(this.index + Number(btn.dataset.dir), true))
        );
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go), true)));
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });
        this.addEventListener('touchstart', (e) => (this.touchX = e.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - (this.touchX ?? 0);
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
        });

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduce && !this.hasAttribute('data-design-mode');
        this.delay = Number(this.dataset.speed || 7) * 1000;
        ['mouseenter', 'focusin'].forEach((ev) => this.addEventListener(ev, () => this.stop()));
        ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => this.start()));

        this.slides.forEach((slide) => {
          slide.addEventListener('shopify:block:select', () => {
            this.stop();
            this.go(Number(slide.dataset.index));
          });
        });

        this.go(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        if (!this.autoplay) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      }

      stop() {
        clearInterval(this.timer);
      }

      go(target, byUser = false) {
        const count = this.slides.length;
        this.index = (target + count) % count;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('aria-hidden', !active);
          slide.inert = !active;
        });
        this.dots.forEach((dot, i) => dot.toggleAttribute('aria-current', i === this.index));
        this.track.style.setProperty('--dw-ss-index', this.index);
        this.syncVideos();
        if (byUser) this.start();
      }

      syncVideos() {
        this.slides.forEach((slide, i) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (i === this.index) video.play().catch(() => {});
          else video.pause();
        });
      }
    }
  );
}
